interface AccountSwitchProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-labelledby'?: string;
}

/** Visually obvious on (blue) vs off (gray) for auto-purchase and similar. */
export function AccountSwitch({
  checked,
  onCheckedChange,
  disabled,
  id,
  'aria-labelledby': ariaLabelledBy
}: AccountSwitchProps) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-labelledby={ariaLabelledBy}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={[
        'relative inline-flex h-8 w-[3.25rem] shrink-0 items-center rounded-full border-2 transition-colors',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2b6cff]',
        checked
          ? 'border-[#1e40af] bg-[#2b6cff] shadow-[inset_0_1px_2px_rgba(0,0,0,0.15)]'
          : 'border-slate-400 bg-slate-300 shadow-inner',
        disabled ? 'cursor-not-allowed opacity-45' : 'cursor-pointer'
      ].join(' ')}
    >
      <span
        aria-hidden
        className={[
          'pointer-events-none absolute top-0.5 h-6 w-6 rounded-full bg-white shadow-md ring-1 ring-slate-900/10 transition-transform duration-200 ease-out',
          checked ? 'translate-x-[1.375rem]' : 'translate-x-0.5'
        ].join(' ')}
      />
      <span className="sr-only">{checked ? 'On' : 'Off'}</span>
    </button>
  );
}
